 
import React, { ReactElement } from 'react';

import { ErrorSummary, ErrorSummaryItem } from '@constellation/core';

import {
  AGREE_TO_TERMS_AND_CONDITIONS,
  CONFIRM_EMAIL_ADDRESS,
  DATE_OF_BIRTH,
  EMAIL_ADDRESS,
  FIRST_NAME,
  LAST_NAME,
} from '../../../utils/constant';

interface ErrorListProps {
  errors?: any;
  errorHeading?: string;
  minorUserError?: string;
}

function AboutYouNotification({
  errors,
  errorHeading,
  minorUserError,
}: ErrorListProps): ReactElement {

  return (
    <>
      {((errors && Object.keys(errors).length > 1) ||
        (errors && Object.keys(errors).length === 1 &&
         errors?.dateOfBirth?.message !== minorUserError)) && (
        <ErrorSummary title={errorHeading}>
          <ErrorSummaryItem className='error-first-name' href={`#${FIRST_NAME}`}>
            {errors?.firstName?.message}
          </ErrorSummaryItem>
          <ErrorSummaryItem className='error-last-name' href={`#${LAST_NAME}`}>
            {errors?.lastName?.message}
          </ErrorSummaryItem>
          {errors &&
            errors.dateOfBirth &&
            errors.dateOfBirth.message !== minorUserError && (
              <ErrorSummaryItem className='error-date-of-birth' href={`#${DATE_OF_BIRTH}`}>
                {errors?.dateOfBirth?.message}
              </ErrorSummaryItem>
            )}
          <ErrorSummaryItem className='error-email-address' href={`#${EMAIL_ADDRESS}`}>
            {errors?.emailAddress?.message}
          </ErrorSummaryItem>
          <ErrorSummaryItem className='error-confirm-your-email-address' href={`#${CONFIRM_EMAIL_ADDRESS}`}>
            {errors?.confirmYourEmailAddress?.message}
          </ErrorSummaryItem>
          <ErrorSummaryItem className='error-terms-and-conditions' href={`#${AGREE_TO_TERMS_AND_CONDITIONS}`}>
            {errors?.agreeToTermsAndConditions?.message}
          </ErrorSummaryItem>
        </ErrorSummary>
      )}
    </>
  );
}

export default AboutYouNotification;
